/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindStateQueryResponse } from './FindStateQueryResponse';
import {
    FindStateQueryResponseFromJSON,
    FindStateQueryResponseFromJSONTyped,
    FindStateQueryResponseToJSON,
} from './FindStateQueryResponse';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';

/**
 * 
 * @export
 * @interface ListStateQueryResponse
 */
export interface ListStateQueryResponse {
    /**
     * 
     * @type {ListMeta}
     * @memberof ListStateQueryResponse
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<FindStateQueryResponse>}
     * @memberof ListStateQueryResponse
     */
    data: Array<FindStateQueryResponse>;
}

/**
 * Check if a given object implements the ListStateQueryResponse interface.
 */
export function instanceOfListStateQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ListStateQueryResponseFromJSON(json: any): ListStateQueryResponse {
    return ListStateQueryResponseFromJSONTyped(json, false);
}

export function ListStateQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListStateQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'data': ((json['data'] as Array<any>).map(FindStateQueryResponseFromJSON)),
    };
}

export function ListStateQueryResponseToJSON(value?: ListStateQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'data': ((value.data as Array<any>).map(FindStateQueryResponseToJSON)),
    };
}

